var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgView = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9698 7.77961C15.9514 7.71801 14.133 1.59961 8.0002 1.59961C1.8674 1.59961 0.049 7.71801 0.0306 7.77961C-0.0102 7.92361 -0.0102 8.07561 0.0306 8.21961C0.049 8.28121 1.8674 14.3996 8.0002 14.3996C14.133 14.3996 15.9514 8.28121 15.9698 8.21961C16.0106 8.07561 16.0106 7.92361 15.9698 7.77961ZM8.00098 12.7992C3.62738 12.7992 1.99138 8.98162 1.64258 7.99922C1.99138 7.01682 3.62738 3.19922 8.00098 3.19922C12.3762 3.19922 14.0122 7.02002 14.3594 7.99922C14.0114 8.98162 12.3746 12.7992 8.00098 12.7992ZM8.0002 9.59963C7.1178 9.59963 6.4002 8.88203 6.4002 7.99963C6.4002 7.11723 7.1178 6.39963 8.0002 6.39963C8.8826 6.39963 9.6002 7.11723 9.6002 7.99963C9.6002 8.88203 8.8826 9.59963 8.0002 9.59963ZM8.00078 4.7998C6.23598 4.7998 4.80078 6.235 4.80078 7.9998C4.80078 9.7646 6.23598 11.1998 8.00078 11.1998C9.76558 11.1998 11.2008 9.7646 11.2008 7.9998C11.2008 6.235 9.76558 4.7998 8.00078 4.7998Z",
    fill: "#202223"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15330_142447",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 16,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9698 7.77961C15.9514 7.71801 14.133 1.59961 8.0002 1.59961C1.8674 1.59961 0.049 7.71801 0.0306 7.77961C-0.0102 7.92361 -0.0102 8.07561 0.0306 8.21961C0.049 8.28121 1.8674 14.3996 8.0002 14.3996C14.133 14.3996 15.9514 8.28121 15.9698 8.21961C16.0106 8.07561 16.0106 7.92361 15.9698 7.77961ZM8.00098 12.7992C3.62738 12.7992 1.99138 8.98162 1.64258 7.99922C1.99138 7.01682 3.62738 3.19922 8.00098 3.19922C12.3762 3.19922 14.0122 7.02002 14.3594 7.99922C14.0114 8.98162 12.3746 12.7992 8.00098 12.7992ZM8.0002 9.59963C7.1178 9.59963 6.4002 8.88203 6.4002 7.99963C6.4002 7.11723 7.1178 6.39963 8.0002 6.39963C8.8826 6.39963 9.6002 7.11723 9.6002 7.99963C9.6002 8.88203 8.8826 9.59963 8.0002 9.59963ZM8.00078 4.7998C6.23598 4.7998 4.80078 6.235 4.80078 7.9998C4.80078 9.7646 6.23598 11.1998 8.00078 11.1998C9.76558 11.1998 11.2008 9.7646 11.2008 7.9998C11.2008 6.235 9.76558 4.7998 8.00078 4.7998Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15330_142447)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgView, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/view.625a5312.svg";
export { ForwardRef as ReactComponent };